import { v4 as uuidv4 } from 'uuid';

export function MinicartProductListProductVariations(props = {}, childrenComponents = []) {
	return {
		componentName: 'MinicartProductListProductVariations',
		componentId: uuidv4(),
		props: Object.assign({}, props),
		childrenComponents,
	};
}
